import React from 'react';
import PropTypes from 'prop-types';
import { WithIconRounded } from 'Components/ProfileMultiProduct/components/designSystem';

const ArrowLeftRightIcon = ({
  round,
  containerColor,
  containerSize,
  color,
  size,
  onClick,
  className,
}) => (
  <WithIconRounded
    round={round}
    containerColor={containerColor}
    containerSize={containerSize}
    className={className}
    onClick={onClick}
  >
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.05 10.0498L18 14.9998L13.05 19.9498L11.636 18.5358L14.172 15.9988L1 15.9998V13.9998H14.172L11.636 11.4638L13.05 10.0498ZM4.95 0.0498047L6.364 1.4638L3.828 3.9998H17V5.9998H3.828L6.364 8.5358L4.95 9.9498L0 4.9998L4.95 0.0498047V0.0498047Z"
        fill={color}
      />
    </svg>
  </WithIconRounded>
);

ArrowLeftRightIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  containerColor: PropTypes.string,
  containerSize: PropTypes.number,
  onClick: PropTypes.func,
  round: PropTypes.bool,
  size: PropTypes.number,
};

ArrowLeftRightIcon.defaultProps = {
  className: 'k-ds-bg-color-light-grey-300',
  color: '#18223D',
  containerColor: null,
  containerSize: 40,
  onClick: null,
  round: false,
  size: 16,
};

export default ArrowLeftRightIcon;
